module.exports = __webpack_public_path__ + "static/media/03-PaddockOutputImprovement.62df158a.gif";